<template>
  <div class="hotRecommendBold">
      更多推荐
  </div>
        
  </template>

<script>
export default {
  name: 'hotRecommendBold',
  props: {
  
  },
 
}
</script>

 
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .hotRecommendBold{
    box-sizing: border-box;
    width: 100%;
    padding:0.22rem 0 0.3rem 0.32rem;
    font-size:0.26rem;
    font-weight:bold; 
    color:rgba(0, 0, 0, 1);
    text-align: left;
    /* border: solid 1px; */
  }
 
</style>
